export default __webpack_public_path__ + "static/media/Gilroy-LightItalic.3da028f1.woff";